
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 1.9a2.08 2.08 0 00-.586.094 1.039 1.039 0 01-.512 1.476 1.039 1.039 0 01-.908-.056A2.095 2.095 0 106 1.9zm5.335 1.826C10.318 1.742 8.305.4 6 .4S1.681 1.743.665 3.726a.607.607 0 000 .548C1.682 6.258 3.695 7.6 6 7.6s4.319-1.343 5.335-3.326a.607.607 0 000-.548zM6 6.7C4.15 6.7 2.455 5.669 1.539 4 2.455 2.331 4.15 1.3 6 1.3S9.545 2.331 10.461 4C9.546 5.669 7.85 6.7 6 6.7z","fill":"#fff"}})])
          )
        }
      }
    